import { authRoutes } from '@auth/routes';
import { routes as communitiesRoutes } from '@communities/routes';
import { routes as systemConfigRoutes } from '@system-config/routes';

/**
 * Application routes
 *
 * Note: Domain-specific routes are imported from their respective domains
 */
export const routes = {
  ...authRoutes,
  ...communitiesRoutes,
  ...systemConfigRoutes,
};
